
<div class="thanks--container_father_thanks">

  <div class="thanks--container_thanks">

    <div class="thanks--container_text_thanks">
      <h2 class="thanks--txt1_thanks">
        Gracias
      </h2>
      <h2 class="thanks--txt2_thanks">
        por participar
      </h2>
    </div>

    <div class="thanks--container_img_thanks">
      <img src="../../assets/logo-thanks.png" alt="thanks-image" class="thanks--img_thanks">
    </div>

  </div>

  <div class="container text-center thanks--father_container">
    <div class="share--bar thanks--container_button">
      <button routerLink="/" class="button button--white">
        <img src="../../assets/arrow.png" alt="return-image" class="thanks--img_return">
        Volver
      </button>
    </div>
  </div>

</div>